import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

export default function OldDetail(props) {
	const { t } = useTranslation();
	const { complaint, row, FileViewer, getStatus } = props;
	return (
		<>
			{row('Number', complaint?.no)}
			{row(
				'Complaint Category',
				complaint?.complaintOnInsuranceCategories === 'COMPLAINT_OF_DISSATISFACTION_ON_INSURANCE'
					? 'Complaint of dissatifaction on insurance'
					: 'Complaint on dispute insurance'
			)}
			{row('Created at', moment(complaint?.createdAt).format('LLL'))}

			<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
				<Text mr="2" fontWeight="500" w="200px">
					{t('Status')}:
				</Text>
				<Box>{getStatus({ settled: complaint?.settled, settledDate: complaint?.settledDate })}</Box>
			</Flex>
			{complaint?.settled && <>{row('Settled at', moment(complaint?.settledDate).format('LLL'))}</>}
			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{complaint?.plaintiff === 'REAL_PERSON' ? t('Natural person') : t('Legal entity')}
			</Text>
			{complaint?.plaintiff === 'REAL_PERSON' && row('Name', complaint?.name)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Gender', t(complaint?.gender))}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Date of birth', complaint?.dob ? moment(complaint?.dob).format('l') : '')}
			{complaint?.plaintiff === 'REAL_PERSON' && row('State', complaint?.state)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('District', complaint?.district)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Commune', complaint?.commune)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Village', complaint?.village)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('Street number', complaint?.streetNumber)}
			{complaint?.plaintiff === 'REAL_PERSON' && row('House number', complaint?.houseNumber)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Company name', complaint?.companyName)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Company objects', complaint?.companyObjects)}
			{complaint?.plaintiff === 'LEGAL_ENTITY' && row('Address', complaint?.address)}
			{row('Phone number', complaint?.phoneNumber)}
			{row('Email', complaint?.email)}
			{row('Social media URL', complaint?.socialMediaUrl)}

			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{t('Detail')}
			</Text>
			{row('Subject', complaint?.subject)}
			{complaint?.complaintType === 'CANCELATION_COMPLAINT' && row('Reason', complaint?.reason)}
			{complaint?.complaintType === 'CANCELATION_COMPLAINT' && row('Complaint ID', complaint?.complaintId)}
			{complaint?.complaintType === 'COMPLAINT' && row('Cause', complaint?.cause)}
			{complaint?.complaintType === 'COMPLAINT' && row('Demand', complaint?.demand)}
			{complaint?.complaintType === 'COMPLAINT' && row('Proof', complaint?.proof)}

			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{t('Plaintiff/Representative')}
			</Text>
			{row('Name', complaint?.plaintiffOrRepresentativeName)}
			{row('Phone number', complaint?.plaintiffOrRepresentativePhoneNumber)}
			<FileViewer
				label="Signature or fingerprint"
				platform={complaint?.platform}
				file={complaint?.signatureOrFingerPrintOfPlaintiffOrRepresentative}
				files={complaint?.signatureOrFingerPrintOfPlaintiffOrRepresentativeMobile}
			/>
			<Text ml="2" mt="4" fontWeight="bold" fontSize="xl">
				{t('Files')}
			</Text>
			{complaint?.complaintType === 'COMPLAINT' && (
				<>
					{complaint?.plaintiff === 'REAL_PERSON' && (
						<FileViewer label="ID card" platform={complaint?.platform} file={complaint?.copyOfIdCard} files={complaint?.copyOfIdCardMobile} />
					)}
					{complaint?.plaintiff === 'LEGAL_ENTITY' && (
						<FileViewer
							label="Business license"
							platform={complaint?.platform}
							file={complaint?.copyOfBusinessLicense}
							files={complaint?.copyOfBusinessLicenseMobile}
						/>
					)}
					{complaint?.plaintiff === 'LEGAL_ENTITY' && (
						<FileViewer label="Insurance agreement" platform={complaint?.platform} file={complaint?.copyOfInsuranceAgreement} />
					)}
					<FileViewer label="Proof file" platform={complaint?.platform} file={complaint?.proofFile} files={complaint?.proofFileMobile} />
					<FileViewer label="Transfer complaint file" platform={complaint?.platform} file={complaint?.transferComplaintFile} />
				</>
			)}
			<FileViewer label="Other file" platform={complaint?.platform} file={complaint?.otherFile} files={complaint?.otherFileMobile} />
		</>
	);
}
